class Accordion {

    constructor() {
        this.$el = $('.js-accordion');

        this.addEventListeners();
    }

    addEventListeners() {
        $('dl', this.$el).on('click', (e) => {
            this.openAccordion($(e.currentTarget));
        });
    }

    openAccordion($target) {
        this.closeAll($target);

        $target.addClass('accordion--active');
        $target.find('dd').slideDown();

        const panelTitle = $target.data('panelTitle');

        if (panelTitle) {
            dataLayer.push({
                event: 'toggleAccordion',
                panelTitle,
            });
        }
    }

    closeAll($target) {
        $('dl', this.$el).each(function () {

            if ($(this).is($target)) {
                return;
            }

            $(this)
                .remove('accordion--active')
                .find('dd')
                .slideUp();
        });
    }
}

new Accordion();

